export default "__VITE_ASSET__CrBcBDnQ__"